exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".button[data-v-edf5a7c8]{z-index:9999;display:flex;align-items:center;justify-content:space-between;padding:20px;background-color:#ffa014;border-top-left-radius:4px;border-top-right-radius:4px;color:#fff;line-height:1;transition:background-color .2s ease-out}.button[data-v-edf5a7c8]:hover{background-color:#f98214;cursor:pointer}.button__text[data-v-edf5a7c8]{flex:0 0 auto;font-size:.9230769231rem;font-weight:bold}.button__icon[data-v-edf5a7c8]{flex:0 0 auto;font-size:1.0769230769rem}.button__icon[data-v-edf5a7c8]:nth-child(n+2){margin-left:12px}", ""]);

// exports
